import { CSSProperties, ReactNode } from 'react';
import { P, T } from '../../../styles/tokens';

interface CaveatProps {
  children: ReactNode;
  /** Text color. Defaults to P.inkSoft (muted ink). */
  color?: string;
  /** Font size in px. Defaults to undefined (inherits). */
  size?: number;
  /** Rotation in degrees. Defaults to 0 (no rotation). */
  rot?: number;
}

export function Caveat({ children, color, size, rot = 0 }: CaveatProps) {
  const style: CSSProperties = {
    fontFamily: T.fontAccent,
    color: color !== undefined ? color : P.inkSoft,
  };
  if (size !== undefined) style.fontSize = size;
  if (rot !== 0) {
    style.transform = `rotate(${rot}deg)`;
    style.display = 'inline-block';
  }

  return (
    <span style={style}>
      {children}
    </span>
  );
}
